export default {
    en: {
        CHAT_ENDED: 'Chat Ended',
        SESSION_HAS_EXPIRED: 'Session has expired',
        BACK: 'Back',
        RESTART: 'Restart',
        SKIP: 'Skip',
        SELECT: 'Select',
        SELECT_FILE: 'Select file',
        DOWNLOAD: 'Download',
        DOWNLOADING: 'Downloading',
        DOWNLOADED: 'Downloaded',
        USER_LAST_MESSAGE_STATUS: ' . Seen',
        INCORRECT_INPUT_VALUE: 'Incorrect input value',
        REQUIRED_FIELD: 'This is a required field',
        INVALID_VALIDATION: 'Invalid validation.',
        QUICK_MENU: 'Quick Menu',
        END_CHAT:'End chat',
        SOUND: 'Sound',
        INPUT_PLACEHOLDER: 'Type your message..',
        OFFLINE_BANNER_TEXT: 'No Internet Connection',
        OFFLINE_MESSAGE_ERROR: 'Not Sent',
        CHANGE_LANGUAGE: 'Change language',
        LANGUAGE: 'Language',
        EMAIL_ADDRESS_LABEL: 'Email Address',
        ENTER_EMAIL_ID: 'Enter Email Id',
        END_CHAT_DISCLAIMER: 'Are you sure you want to end this chat?',
        WAS_THIS_HELPFUL: 'Was this helpful?',
        SCREEN_READER_THUMBS_UP: 'this is helpful',
        SCREEN_READER_THUMBS_DOWN: 'this is not helpful',
        END_CHAT_CONFIRM_BUTTON_CTA: 'End Chat',
        RESTART_CHAT: 'Restart chat',
        SHOW_WARNING: 'Show warning',
        CHAT_RESTART: 'Chat Restarted',
        END_CHAT_CANCEL_BUTTON_CTA: 'Cancel',
        DRAG_DROP_TEXT: 'or drag files here',
        DROP_AREA_TEXT_CW: 'Add a file to the conversation',
        HAS_JOINED_THE_CHAT: 'has joined the chat',
        HAS_LEFT_THE_CHAT: 'has left the chat',
        HAS_TRANSFERRED_THE_CHAT: 'has transferred the chat to',
        QUEUE_POSITION: 'Queue Position:',
        AGENTDESK_CONFIGURATION_NOT_FOUND: 'Unable to connect with Live Agent. Our Virtual Agent can provide you assistance',
        MANDATORY: 'Mandatory',
        MAIL_VALIDATION_MESSAGE: 'Please provide valid email',
        SETTINGS_LABEL: 'Settings',
        MAXIMIZE_LABEL: 'Maximize',
        RESTORE_LABEL: 'Restore',
        HEADER_CLOSE_LABEL: 'Close',
        MINIMIZE_LABEL: 'Minimize',
        CHAT_ENDED_WITH_TRANSCRIPT: 'Chat ended and transcript was sent.',
        TRANSCRIPT_LABEL: 'Transcript',
        RESTART_PRIMARY_BTN_TEXT: 'Restart Chat',
    }
}
